import { Accordion, AccordionItem } from '@heroui/react';
import { useFormContext } from 'react-hook-form';
import type { IExaminerQuestionSchema } from './schema';

export const StationQuestionsPreview = () => {
  const { getValues } = useFormContext<{ examinerQuestions?: IExaminerQuestionSchema[] | null }>();
  const examinerQuestions = getValues('examinerQuestions') ?? [];
  return (
    <div className='mb-4'>
      <Accordion variant='splitted' defaultExpandedKeys={['1']} className='space-y-2' selectionMode='single'>
        <AccordionItem
          classNames={{
            content: 'pt-0 border-t border-default-200',
            title: 'font-medium px-4',
            base: 'shadow-none border border-default-200 rounded-md pl-0',
          }}
          key={'1'}
          title={`Examiner Viva Questions (${examinerQuestions.length})`}
        >
          <div className='p-4 grid grid-cols-1 divide-y divide-default-200 gap-2'>
            {examinerQuestions.length === 0 ? (
              <div className='text-default-500 text-sm text-center py-2'>--</div>
            ) : (
              examinerQuestions.map((question) => (
                <div key={question.index} className='flex items-center gap-2'>
                  <span className='text-default-500 text-sm'>#{question.index}.</span>
                  <span>{question.question}</span>
                </div>
              ))
            )}
          </div>
        </AccordionItem>
      </Accordion>
    </div>
  );
};
